export const USER_SET = 'USER_SET'
export const USER_CLEAR = 'USER_CLEAR'
export const SET_CURRENT_QUERIES = 'SET_CURRENT_QUERIES'
export const CLEAR_CURRENT_QUERIES = 'CLEAR_CURRENT_QUERIES'

export const TREND_ADD = 'TREND_ADD'
export const TRENDS_CLEAR = 'TRENDS_CLEAR'
export const CACHED_TRENDS_SET = 'CACHED_TRENDS_SET'


// WEBPACK FOOTER //
// ./src/js/store/mutation-types.js